import React from "react";
import ScheduleCreationForm from "./SchedulingDetails/Common/ScheduleCreationForm.logic";

const ScheduleLandingPage = (): JSX.Element => {

  return (
    <ScheduleCreationForm />);
};

export default ScheduleLandingPage;
